import { SurveyV2, UserDto } from '@act/shared/data-transfer-objects';
import { Box, SurveyTemplateParser } from '@act/storybook';
import { Typography } from '@mui/material';

interface PromptProps {
  prompt: SurveyV2.PromptDto;
  assignedSurvey: SurveyV2.AssignedSurveyDto;
  member: UserDto;
}

const Prompt = ({ prompt, assignedSurvey, member }: PromptProps) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="8px"
      margin="16px 16px 16px 0"
      padding="24px"
      background="#fbfcfe"
      borderRadius="8px"
      border="1px solid #dce4e8"
    >
      <Typography variant="subheadLarge" fontWeight={600}>
        <SurveyTemplateParser
          template={prompt?.title}
          member={member}
          assignedSurvey={assignedSurvey}
        />
      </Typography>
      <Typography variant="subheadLarge" fontWeight={400}>
        <SurveyTemplateParser
          template={prompt?.text}
          member={member}
          assignedSurvey={assignedSurvey}
        />
      </Typography>
    </Box>
  );
};

export default Prompt;
